import {Component, OnInit} from '@angular/core';
import {CareService} from '../../../admin-services/care.service';
import {finalize, first} from 'rxjs/operators';
import {RouterLink} from '@angular/router';
import {DatePipe, NgFor, NgIf} from '@angular/common';

@Component({
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.scss'],
    standalone: true,
  imports: [NgIf, NgFor, RouterLink, DatePipe]
})
export class PartnersComponent implements OnInit {

  public partnerList: any[];
  public isloading = false;

  constructor(
    private careService: CareService
  ) { }

  ngOnInit(): void {
    this.isloading=true;
    this.careService.getPartners('ACCOMMODATION').pipe(
      first(),
      finalize(() => {
        this.isloading = false;
      })
      ).subscribe( data => {
      this.partnerList = data;
      }
    );
  }

}
